var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "url(#paint0_linear_5489_35640)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3333 17H20.3333C18.4833 17 17 18.5 17 20.3333V43.6667C17 45.5 18.4833 47 20.3333 47H43.6667C45.5 47 47 45.5 47 43.6667V23.6667L40.3333 17ZM32 43.6667C29.2333 43.6667 27 41.4333 27 38.6667C27 35.9 29.2333 33.6667 32 33.6667C34.7667 33.6667 37 35.9 37 38.6667C37 41.4333 34.7667 43.6667 32 43.6667ZM37 27H20.3333V20.3333H37V27Z",
    fill: "#FBFBFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5489_35640",
    x1: 2.58586,
    y1: 7.61801e-7,
    x2: 43.2411,
    y2: 52.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF2573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC1A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.42e4452f667c6a34afd28341c9b6cb2b.svg";
export { ForwardRef as ReactComponent };